<template>
    <div class="panel panel-default" data-testid="order-detail-summary">
        <div class="panel-heading">
            <h4><od-icon name="shopping-cart" :size="16" /> {{ order.ui.labels.summary || 'Riepilogo ordine' }}</h4>
        </div>
        <div class="panel-body no-padding">
            <dl class="order-detail-v1-field-grid">
                <div
                    v-for="item in items"
                    :key="item.label"
                    class="order-detail-v1-field-grid__cell"
                >
                    <dt>{{ item.label }}</dt>
                    <dd
                        :data-testid="item.testId || null"
                    >{{ item.value }}</dd>
                </div>
            </dl>
        </div>
    </div>
</template>

<script>
import OdIcon from './OdIcon.vue';

export default {
    name: 'OrderSummaryCard',
    components: { OdIcon },
    props: {
        order: {
            type: Object,
            required: true,
        },
    },
    computed: {
        items() {
            const h = this.order.header;
            const billing = this.order.billingAddress || {};

            return [
                { label: 'Nominativo', value: billing.name || '—' },
                { label: 'Email', value: h.email || '—' },
                { label: 'Pagamento', value: h.paymentLabel },
                { label: 'Importo pagato', value: h.amountPaidFormatted },
                { label: 'Totale lordo righe', value: h.linesGrossTotalFormatted },
                { label: 'Delta rimborso', value: h.refundDeltaFormatted, testId: 'order-detail-refund-delta' },
                { label: 'Tracking', value: h.trackingNumber || '—' },
                { label: 'Coupon', value: h.coupon || 'Nessuno' },
                { label: 'Reso', value: h.isReturn ? 'Sì' : 'No' },
                { label: 'Note', value: h.notes || '—' },
            ];
        },
    },
};
</script>
